module.exports = "<!-- <go-navbar></go-navbar> -->\n<!-- <go-home></go-home> -->\n<!-- <app-index></app-index> -->\n<router-outlet></router-outlet>\n"